import { usePatchApiAdminUserSetActiveStatus, } from '../../generated/sitComponents';
export function usePatchAdminUserActiveStatus(options) {
    return usePatchApiAdminUserSetActiveStatus({
        ...options,
        onSuccess: (data, variables, onMutateResult, context) => {
            context.client.invalidateQueries({ queryKey: ['admin', 'users'] });
            options?.onSuccess?.(data, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-patch-admin-user-active-status.js.map